import React from 'react';
import { Box } from '@mui/material';

export interface ListPageFiltersSectionProps {
  children: React.ReactNode;
}

const ListPageFiltersSection: React.FC<ListPageFiltersSectionProps> = ({ children }) => (
  <Box
    sx={{
      bgcolor: 'background.default',
      width: '100%',
    }}
  >
    {children}
  </Box>
);

export default ListPageFiltersSection;
